import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { clone as e } from "./lang.js";
import t from "./Logger.js";
import r from "./Message.js";

var s = /*#__PURE__*/function (_r) {
  _inherits(s, _r);

  var _super = _createSuper(s);

  function s(e, t, r) {
    var _this;

    _classCallCheck(this, s);

    if (_this = _super.call(this, e, t, r), !(_assertThisInitialized(_this) instanceof s)) return _possibleConstructorReturn(_this, new s(e, t, r));
    return _possibleConstructorReturn(_this);
  }

  _createClass(s, [{
    key: "toJSON",
    value: function toJSON() {
      if (null != this.details) try {
        return {
          name: this.name,
          message: this.message,
          details: JSON.parse(JSON.stringify(this.details, function (t, r) {
            if (r && "object" == typeof r && "function" == typeof r.toJSON) return r;

            try {
              return e(r);
            } catch (_s) {
              return "[object]";
            }
          }))
        };
      } catch (r) {
        throw t.getLogger("esri.core.Error").error(r), r;
      }
      return {
        name: this.name,
        message: this.message,
        details: this.details
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(e) {
      return new s(e.name, e.message, e.details);
    }
  }]);

  return s;
}(r);

s.prototype.type = "error";
export { s as default };